const table = () => {
	var newWindowWidth = $(window).width()
	if (newWindowWidth < 767) {
		$('table').wrap("<div style='overflow-x:auto;'></div>")
	}
}
export { table }
